import { history } from "@umijs/max";
import { useSearchParams } from "@umijs/max";
import { message, notification } from "antd";
import { trimS } from "@/components";
export default {
  form: {
    rowGutter: [80, 0],
    span: 6,
    md: 6,
    sm: 12,
    validate: {
      max: 50,
      min: 1,
    },
    bTime: 500,
    fileMax:1024*1024*20,
    fileMaxName:'20M',
  },
  table: {
    size: "middle",
  },
  layout: {
    showBread: true,
  },
  search: {
    width: "200px",
    dateRangeWidth: "240px",
    gap: "middle",
  },
  globalConfig: {
    TIANDITU_KEY: "728e9db9734cc20f0401c231567b4468",
    TIANDITU_SCRIPT_ID: "tianditu-map-js-api-v4",
  },
  loadingTip:"加载中...",
  getPageType: (): number => {
    const currentUrl = history.location.pathname;
    const pageName: string = currentUrl.split("/").pop() as string;
    if (pageName.indexOf("add") > -1) {
      return 1;
    } else if (pageName.indexOf("edit") > -1) {
      return 2;
    } else if (pageName.indexOf("view") > -1) {
      return 3;
    } else if (pageName.indexOf("handle") > -1) {
      return 4;
    } else if (pageName.indexOf("charge") > -1) {
      return 5;
    } else {
      return 999;
    }
  },
  getPageTypeName: ():string => {
    const currentUrl = history.location.pathname;
    const pageName: string = currentUrl.split("/").pop() as string; 
    if (pageName.indexOf("add") > -1) {
      return '添加';
    } else if (pageName.indexOf("edit") > -1) {
      return '编辑';
    } else if (pageName.indexOf("view") > -1) {
      return '查看';
    } else {
      return "";
    }
  },
  getPageId: (op = "id"): any => {
    //获取 url的参数
    const [searchParams] = useSearchParams();
    const idStr = searchParams.get(op);
    return idStr?.trim();
  },
  getEmptyType: (searchParams: any) => {
    // 检查是否有搜索条件
    const hasSearchConditions = Object.values(searchParams).some(
      (value) =>
        (typeof value === "string" && value) ||
        (typeof value === "number" && value !== undefined)
    );
    return hasSearchConditions ? "searchEmpty" : "noData";
  },
  getDate: (d: string) => {
    if (d) {
      return d.slice(0, 16);
    } else {
      return "";
    }
  },
  getDateRange: (d: string, d1: string) => {
    let dd = d?.slice(0, 10);
    let dd1 = d1?.slice(0, 10);
    if (!dd && dd1) {
      return "";
    }
    return [dd, dd1].join(" 至 ");
  },
  validateSearchParams: (searchParams: any) => {
    return new Promise((resolve, reject) => {
      let error = 0;
      let msg = "";
      if (!searchParams.dateRange) {
        msg = "请选择日期范围";
        error++;
      }
      if (!trimS(searchParams.merchantId)) {
        msg = "请选择商户";
        error++;
      }
      if (!trimS(searchParams.areaId)) {
        msg = "请选择片区";
        error++;
      }
      if (error) {
        message.error(msg);
        reject(false);
      } else {
        resolve(true);
      }
    });
  },
};
